export const CAMPAIGN_SUBMISSIONS_LIST = '/v1/campaign-submissions';
export const CAMPAIGN_SUBMISSION_DETAILS = '/v1/campaign-submissions/';
export const APP_SUMO_CODES = '/appsumo/appsumocodes';



// WEBPACK FOOTER //
// ./src/hooks/react-query/queries.js